import { C2cWeightAndSizeModel } from '../models';

export const C2C_WEIGHT_AND_SIZE_INIT: C2cWeightAndSizeModel = {
};
